import { Component, EventEmitter, OnDestroy, OnInit, Output, ElementRef, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccountManagementService } from '../../services/account-management.service';
import { JournodexRegionsService } from '../../../../Common/Journodex/services/journodex-regions.service';
import { WireRegion } from '../../../../api/wire/enums/wire-region.enum';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { WireQuotaApiModel } from '../../../../api/wire/models/wire-quota-api.model';


@Component({
    selector: 'agpr-newswire-preferences',
    templateUrl: './newswire-preferences.component.html',
    styleUrls: ['./newswire-preferences.component.scss'],
    standalone: false
})
export class NewswirePreferencesComponent implements OnDestroy, OnInit, AfterViewInit {

    subscriptions: Subscription[] = [];

    isReadOnly: boolean = false;

    wireQuotas: WireQuotaApiModel[] = [];
    readonly wireRegions = WireRegion;
    readonly buttonTypes = ButtonTypesEnum;
    regionDropdownOptions: DropdownOptionModel[] = [
        {
            value: WireRegion.canada,
            label: 'WireRegion.' + WireRegion.canada
        },
        {
            value: WireRegion.north_america,
            label: 'WireRegion.' + WireRegion.north_america
        },
        {
            value: WireRegion.united_kingdom,
            label: 'WireRegion.' + WireRegion.united_kingdom
        },
        {
            value: WireRegion.united_states,
            label: 'WireRegion.' + WireRegion.united_states
        }
    ];
    optionsToDisplay: DropdownOptionModel[];
    selectedRegion;
    newQuotaRegion: ElementRef;
    showRegionDropdown: boolean = false;
    dirty: boolean = false;

    @Output() quotaAdded: EventEmitter<ElementRef> = new EventEmitter<ElementRef>();
    @ViewChildren('quotaCard') quotaCards: QueryList<ElementRef>;

    constructor(
        public accountManagementService: AccountManagementService,
        public journodexRegionsService: JournodexRegionsService
    ) {
    }

    ngOnInit(): void {
        this.subscriptions = [];
        this.subscriptions.push(
            this.accountManagementService.getWireQuotas().subscribe(quotas => {
                if (!!quotas) {
                    this.wireQuotas = quotas;
                } else {
                    this.wireQuotas = [];
                }
                this.updateOptionsToDisplay();
            }),
            this.accountManagementService.getReadOnly().subscribe(result => {
                this.isReadOnly = result;
            })
        );
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(
            this.quotaCards.changes.subscribe(change => {
                if (this.dirty) { // Stops scrolling to bottom when page loads
                    const lastQuota = change.last as ElementRef;
                    if (!!lastQuota) {
                        this.newQuotaRegion = lastQuota;
                        this.quotaAdded.emit(this.newQuotaRegion);
                    } else {
                        this.newQuotaRegion = null;
                    }
                }
            })
        );
    }


    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    addQuota(region: WireRegion) {
        this.dirty = true;
        const newQuota = {
            region: region,
            baselineWires: 0,
            additionalWires: 0,
            usedWires: 0
        };
        this.wireQuotas.push(newQuota);
        this.updateOptionsToDisplay();
        this.selectedRegion = {};
        this.showRegionDropdown = false;
    }

    updateOptionsToDisplay(): void {
        this.optionsToDisplay = this.regionDropdownOptions.filter(dropdown => {
            return this.wireQuotas.findIndex(quota => quota.region === dropdown.value) === -1;
        });
    }

    removeQuota(index: number) {
        this.dirty = true;
        this.wireQuotas.splice(index, 1);
        this.updateOptionsToDisplay();
    }

}
